<template>
  <el-dialog @opened="onDialogOpened" :visible.sync="detailShow" :show-close="false" :close-on-click-modal="false"
             width="100%"
             top="0"
             class="dialogStyle"
             v-loading="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading">
    <div class="dialogDiv">
      <el-row style="height: 6rem">
        <el-col :span="24" style="background-color: #fbfbfb;height: 100%;display: flex;justify-content: space-between">
          <div style="height: 100%;display: flex;align-items: center;">
            <img src="../../assets/icons/monitor/station.svg" />
            <el-select class="searhInput" v-model="mpcd" @change="onStationChange" filterable placeholder="测点" size="small">
              <el-option
                  v-for="item in mps"
                  :key="item.mpcd"
                  :label="item.mpcd"
                  :value="item.mpcd">
              </el-option>
            </el-select>
            <el-button v-for="item in tabArr" :key="item.value" :class="activeButton === item.value ?'selectButton':'noSelectButton'" class="tabButton"
                       @click="onTypeChange(item.value)">{{ item.label }}
            </el-button>
          </div>
          <el-image class="tabDelImg" :src="require('../../assets/tab-del.png')"
                    @click="onReturn" fit="contain" style="cursor: pointer;"></el-image>
          <!--          <div class="showSearch" style="padding: 1rem 2rem;">
                      <el-button @click="onTypeChange('1')" :class="activeButton === '1' ? 'activeButton' : 'normalButton'" type="primary" size="small" round>监测</el-button>
                      <el-button @click="onTypeChange('2')" :class="activeButton === '2' ? 'activeButton' : 'normalButton'" type="primary" size="small" round>日</el-button>
                      <el-button @click="onTypeChange('3')" :class="activeButton === '3' ? 'activeButton' : 'normalButton'" type="primary" size="small" round>基本信息</el-button>
                    </div>-->
        </el-col>
      </el-row>
      <el-row style="height: calc(100% - 6rem)">
        <el-row style="height:  7.2rem" v-show="dateShow">
          <el-col :span="24" style="display: flex;align-items: center;height: 100%">
            <div  class="showSearch" >
              <span style="font-family: 'PingFang SC';margin-right: 1.4rem;height: 100%;display: flex;align-items: center;font-size: 1.4rem;justify-content: center">时间</span>
              <el-date-picker
                  size="small"
                  @change="onDateChange"
                  v-model="dateTime"
                  :type="dateType"
                  range-separator="-"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  class="searchDate"
                  :clearable="false"
                  :value-format="timeFormat"
                  :format="showFormat"
              >
              </el-date-picker>
              <el-button type="primary" size="small" class="searchButton"  icon="el-icon-search" style="width: 10.6rem" @click="query">
                查询
              </el-button>
              <el-button
                  type="primary"
                  size="small"
                  class="queryButton queryButtonPadding qDcBtn"
                  @click="download">
                <el-image class="qDcImg" :src="require('@/assets/buttonGathers/query-dc.png')"></el-image>
                &nbsp;导出
              </el-button>
            </div>
          </el-col>
        </el-row>
          <detail ref="detail" v-show="activeButton === 1" ></detail>
          <daily ref="daily" v-show="activeButton === 2" ></daily>
          <basic ref="basic" v-show="activeButton === 3" ></basic>
      </el-row>
    </div>
  </el-dialog>
</template>
<script setup>
  import Detail from "./detail";
  import Daily from "./daily";
  import Basic from "./basic";
  // const types = {'SPPR': '0602','PZWL':'0601','ST':'0603','SRHRDS':'0604','SRVRDS':'0605'};

  export default {
    components: {Basic, Daily, Detail},
    data() {
      return {
        detailShow: false,
        mps: [],
        activeButton: 1,
        columns: [],
        type:'',
        mpcd: '',
        maxHeight: 0,
        detailInit: true,
        dailyInit: true,
        basicInit: true,
        dateTime:[],
        loading: false,
        dateType:'datetimerange',
        dateShow: true,
        tmpTime: [],
        tmpDate: [],
        timeFormat: 'yyyy-MM-dd HH:mm:ss',
        tabArr:[{label:'监测',value: 1},{label:'日',value:2},{label:'基本信息',value:3}],
        grid: {},
        showFormat: 'yyyy-MM-dd HH:mm'
      }
    },
    methods: {
      onStationChange(val){
        if(this.activeButton === 1){
          this.$refs.detail.changeMpcd(val);
        }else if(this.activeButton === 2){
          this.$refs.daily.changeMpcd(val);
        }
        this.query();
      },
      onDateChange(val){
        if(this.activeButton === 1){
          const time = [val[0].substring(11,19),val[1].substring(11,19)];
          this.tmpTime = time;
          this.$refs.detail.changeTime(val);
        }else if(this.activeButton === 2){
          this.$refs.daily.changeTime(val);
        }
      },
      queryStations(params){
        this.request.get('/rm-bmp/queryMpOrStbprp',{params}).then(res =>{
          if(res.ok){
            this.mps = res.data;
          }else {
            this.$message.error(res.error.message);
          }
        });
      },
      query(){
        const startTime = new Date(this.dateTime[0]);
        const endTime = new Date(this.dateTime[1]);
        if(startTime.getTime() + 3600000 * 24 * 365 < endTime.getTime()){
          this.$message.warning('查询时间间隔需小于一年！');
          return;
        }
        this.loading = true;
        if(this.activeButton === 1){
          this.$refs.detail.queryData(this.type,this.mpcd,this.dateTime,this.onChange);
        }else if(this.activeButton === 2){
          this.$refs.daily.queryData(this.type,this.mpcd,this.dateTime,this.onChange);
        }else if(this.activeButton === 3){
          this.$refs.basic.queryData(this.mpcd,this.onChange);
        }
      },
      onChange(loading){
        this.loading = loading
      },
      onReturn(){
        this.activeButton = 1;
        // this.$parent.onDetailOpen(false);
        this.detailShow = false;
        this.dateType = 'datetimerange';
        this.timeFormat= 'yyyy-MM-dd HH:mm:ss';
        this.showFormat = 'yyyy-MM-dd HH:mm';
      },
      onDialogOpened(){
        this.$refs.detail.initCondition(this.columns,this.type,this.mpcd,this.dateTime,this.grid);
        this.$refs.detail.addResize();
        this.query();
      },
      initColumns(columns,type,mpcd,dateTime,grid){
        this.columns = columns;
        this.type = type;
        this.mpcd = mpcd;
        this.grid = grid;
        //调用子组件方法进行查询
        this.basicInit = true;
        this.detailInit = true;
        this.dailyInit = true;
        this.dateTime = dateTime;
        const params = {type: type};
        this.queryStations(params);
        this.detailShow = true;
        const time = [dateTime[0].substring(11,19),dateTime[1].substring(11,19)];
        console.log(time);
        this.tmpTime = time;
      },
      onTypeChange(type){
        if(1 === type){
          if(this.dateType !== 'datetimerange'){
            const time = [this.dateTime[0]+' '+this.tmpTime[0],this.dateTime[1]+' '+this.tmpTime[1]];
            this.dateTime = time;
          }
          this.dateType = 'datetimerange';
          this.dateShow = true;
          this.timeFormat='yyyy-MM-dd HH:mm:ss';
          this.showFormat = 'yyyy-MM-dd HH:mm';
          this.loading = true;
          if(this.activeButton === 2){
            this.$refs.daily.cancelResize();
          }
          this.$refs.detail.addResize();
          this.$refs.detail.queryData(this.type,this.mpcd,this.dateTime,this.onChange);
        }else if(2 === type){
          this.dateShow = true;
          if(this.dateType === 'datetimerange'){
            const date = [this.dateTime[0].substring(0,10),this.dateTime[1].substring(0,10)];
            this.dateTime = date;
          }
          this.dateType = 'daterange';
          this.timeFormat = 'yyyy-MM-dd';
          this.showFormat = 'yyyy-MM-dd';
          if(this.dailyInit){
            this.dailyInit = false;
            this.$refs.daily.initCondition(this.columns,this.type,this.mpcd,this.dateTime);
          }
          this.loading = true;
          if(this.activeButton === 1){
            this.$refs.detail.cancelResize();
          }
          this.$refs.daily.addResize();
          this.$refs.daily.queryData(this.type,this.mpcd,this.dateTime,this.onChange);
        }else if(3 === type){
          this.dateShow = false;
          this.loading = true;
          this.$refs.daily.cancelResize();
          this.$refs.detail.cancelResize();
          this.$refs.basic.queryData(this.mpcd,this.onChange);
        }
        this.activeButton = type;
      },
      download() {
        let b = {
          mstp: this.type,
          mpcd: this.mpcd,
          mstmGE: this.dateTime[0],
          mstmLE: this.dateTime[1],
        };
        if(this.activeButton === 1){
          this.request.get('/rm-rpzwl/v1/detail/export',{ params: b,responseType: "blob" }).then((res) => {
            try {
              let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
              const a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              // 这里填保存成的文件名
              a.download = decodeURI(res.headers["content-disposition"].split(";")[1].split("=")[1]);
              a.click();
              URL.revokeObjectURL(a.href);
              return;
            } catch (error) {
              const reader = new FileReader();
              reader.readAsText(res.data, 'utf-8');
              let _this = this;
              reader.onload=function(){
                const msg = JSON.parse(reader.result);
                if (!msg.ok) {
                  if (msg.error.code == 3001) {
                    _this.$message.error(msg.error.message);
                  } else {
                    _this.$message.warning(msg.error.message);
                  }
                }
              }
            }
          });
        }else if(this.activeButton === 2){
          this.request.get('/rm-dpzwl/v1/detail/export',{ params: b,responseType: "blob" }).then((res) => {
            try {
              let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
              const a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              // 这里填保存成的文件名
              a.download = decodeURI(res.headers["content-disposition"].split(";")[1].split("=")[1]);
              a.click();
              URL.revokeObjectURL(a.href);
            } catch (error) {
              const reader = new FileReader();
              reader.readAsText(res.data, 'utf-8');
              let _this = this;
              reader.onload=function(){
                const msg = JSON.parse(reader.result);
                if (!msg.ok) {
                  if (msg.error.code == 3001) {
                    _this.$message.error(msg.error.message);
                  } else {
                    _this.$message.warning(msg.error.message);
                  }
                }
              }
            }
          });
        }
      }
    }
}
</script>
<style scoped>
  /*去除头部*/
  ::v-deep .el-dialog__header{
    display: none;
  }
  /*去除尾部*/
  ::v-deep .el-dialog__footer{
    display: none;
  }
  ::v-deep .el-dialog__body{
    height: 100%;
    padding: 0px;
  }
  ::v-deep .el-dialog{
    margin-bottom:0;
    height: 100%;
  }
  .tabDelImg {
    width: 3rem;
    height: 100%;
    margin-right: 3rem;
    display: flex;
    align-items: center;
  }
  .dialogStyle{
    height: calc(100% - 11rem);
    margin-top: 11rem;
    box-sizing: border-box
  }
  .dialogDiv{
    width: calc(100% - 4rem);
    height: calc(100% - 4rem);
    padding: 2rem;
    background-color: rgb(247, 247, 247);

  }
  .showSearch{
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .tabButton {
    width: auto;
    height: 3.6rem;
    font-family: PingFang SC;
    font-size: 1.4rem;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0rem;
    border-radius: 0.5rem;
    border: solid 0rem #f4f4f4;
    margin-left: 2rem;
    padding-left: 2.5rem;
    padding-right: 2.5rem;

  }
  .searhInput{
    width: 12rem;
    margin-left: 1.5rem;
    color: #53abfd;
  }
  .searchDate{
    width: 36rem;
  }
  .searchButton{
    margin-left: 1.5rem;
  }

  .noSelectButton {
    background-color: #f7f7f7;
    color: #323232;
  }

  .selectButton {
    background-color: #53abfd;
    color: #ffffff;
  }

  ::v-deep .qDcBtn {
      position: absolute;
      right: 4rem;
  }

  ::v-deep .qDcImg {
      width: 1.2rem;
      height: 1.2rem;
  }
</style>
